import { useState } from 'react';
import type { FunctionComponent } from 'react';
import { CSSTransition } from 'react-transition-group';
import type { CSSTransitionProps } from 'react-transition-group/CSSTransition';
import { useTimeoutFn } from 'react-use';
import { useEffectSound } from '../../utils/sound';

export interface StateProps {
	soundEnabled: boolean;
	soundVolume: number;
}

export interface DispatchProps {}

export type OwnProps = CSSTransitionProps & {
	timeout: number;
	delay?: number;
	soundUrl: string;
};

type Props = StateProps & DispatchProps & OwnProps;

const SoundCSSTransition: FunctionComponent<Props> = (props: Props) => {
	const {
		soundUrl,
		soundEnabled,
		soundVolume,
		delay = 0,
		timeout,
		...otherProps
	} = props;
	const [visible, setVisible] = useState(false);
	const play = useEffectSound(soundUrl, soundEnabled, soundVolume);

	useTimeoutFn(() => {
		setVisible(true);
		play(timeout);
	}, delay);

	return <CSSTransition in={visible} timeout={timeout} {...otherProps} />;
};

export default SoundCSSTransition;
